import { useState } from "react";
import { AttachmentProps, FullScreenModal } from "../../../libs";
import * as Styled from "./AttachmentsDisplay.styled";
import defaultThumbnail from "../../../assets/images/default_thumbnail.jpeg";

export const AttachmentsDisplay: React.FC<AttachmentProps> = ({
    attachments,
    uploadedImages,
    onRemoveImage
}) => {
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);

    // ✅ Open modal with selected image
    const handleImageClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setIsImageModalOpen(true);
    };

    // ✅ Close modal
    const handleCloseImageModal = () => {
        setIsImageModalOpen(false);
        setSelectedImage(null);
    };

    return (
        <>
            <Styled.AttachmentsWrapper>
                {/* ✅ Ticket Replies Attachments */}
                {attachments.map((attachment, index) => (
                    <Styled.AttachmentContainer
                        key={`reply-${index}`}
                        onClick={() => handleImageClick(attachment.url)}
                    >
                        <Styled.AttachmentImage
                            src={attachment.url || defaultThumbnail}
                            alt={`Attachment ${index + 1}`}
                            onError={(e) => {
                                (e.target as HTMLImageElement).src = defaultThumbnail;
                            }}
                        />
                    </Styled.AttachmentContainer>
                ))}

                {/* ✅ Uploaded Images */}
                {uploadedImages.map((image, index) => (
                    <Styled.AttachmentContainer
                        key={`upload-${index}`}
                        onClick={() => handleImageClick(image.previewUrl)}
                    >
                        <Styled.AttachmentImage
                            src={image.previewUrl || defaultThumbnail}
                            alt={`Uploaded ${index + 1}`}
                            onError={(e) => {
                                (e.target as HTMLImageElement).src = defaultThumbnail;
                            }}
                        />
                        {onRemoveImage && (
                            <Styled.RemoveIcon onClick={() => onRemoveImage(index)}>X</Styled.RemoveIcon>
                        )}
                    </Styled.AttachmentContainer>
                ))}
            </Styled.AttachmentsWrapper>

            {/* ✅ Fullscreen Modal */}
            {isImageModalOpen && selectedImage && (
                <FullScreenModal
                    show={isImageModalOpen}
                    onHide={handleCloseImageModal}
                    style={{ overflow: "hidden" }}
                    showHeader={false}
                    body={(
                        <Styled.FullScreenImageContainer>
                            <Styled.FullScreenImage
                                src={selectedImage}
                                alt="Fullscreen"
                                onError={(e) => {
                                    (e.target as HTMLImageElement).src = defaultThumbnail;
                                }}
                            />
                        </Styled.FullScreenImageContainer>
                    )}
                />
            )}
        </>
    );
};

